import CollaborationImage from '../../assets/collaboration-img.webp';
import DesignPluginImage from '../../assets/design-plugin-img.webp';
import DevHubImage from '../../assets/devhub-img.webp';
import IntegrationsImage from '../../assets/integrations-img.webp';
import AppierLogoImage from '../../assets/logos/appier-logo.svg';
import ElliLogoImage from '../../assets/logos/elli-logo.svg';
import HyundaiLogoImage from '../../assets/logos/hyundai-logo.svg';
import KintoLogoImage from '../../assets/logos/kinto-logo.svg';
import MangoLogoImage from '../../assets/logos/mango-logo.svg';
import MastercardLogoImage from '../../assets/logos/mastercard-logo.svg';
import PleoLogoImage from '../../assets/logos/pleo-logo.svg';
import PreziLogoImage from '../../assets/logos/prezi-logo.svg';
import RevolutLogoImage from '../../assets/logos/revolut-logo.svg';
import WeverseLogoImage from '../../assets/logos/weverse-logo.svg';
import WithingsLogoImage from '../../assets/logos/withings-logo.svg';
import LokaliseAiImage from '../../assets/lokalise-ai-img.webp';

const SLIDES = [
    {
        id: 1,
        title: 'Speed up with AI Translations',
        description: 'Get on-brand, accurate, and context-specific translations, in less time and with just one click.',
        imageSrc: LokaliseAiImage,
        companyLogos: [AppierLogoImage, KintoLogoImage],
    },
    {
        id: 2,
        title: 'Easier to manage and collaborate',
        description: 'Collaborate, manage and review translations in a productive, flexible and efficient way.',
        imageSrc: CollaborationImage,
        companyLogos: [MangoLogoImage, HyundaiLogoImage, WeverseLogoImage],
    },
    {
        id: 3,
        title: 'Connect with 50+ integrations',
        description: 'Localize whatever you need to with our range of integrations, file formats and capabilities.',
        imageSrc: IntegrationsImage,
        companyLogos: [PreziLogoImage, PleoLogoImage, MastercardLogoImage],
    },
    {
        id: 4,
        title: 'API, CLI, SDKs, Webhook & Automation',
        description:
            'Automate processes, eliminate routine tasks, and track progress with ease with our developer tools.',
        imageSrc: DevHubImage,
        companyLogos: [ElliLogoImage, RevolutLogoImage],
    },
    {
        id: 5,
        title: 'Design plugin to improve quality',
        description:
            'Use the design plugins to automatically share new design content and provide translation context.',
        imageSrc: DesignPluginImage,
        companyLogos: [RevolutLogoImage, WithingsLogoImage, KintoLogoImage],
    },
];

export { SLIDES };
